import $ from 'jquery';
import 'slick-carousel';
import getLayout from './get-modal-layout';
import {getSiblings} from './utils';
import Modal from './modal';

const classNames = {
  options: {
    optionActive: `modal-floors__option--active`
  },
  footer: {
    static: `page-footer--static`
  }
};
const texts = {
  floor: {
    ru: `этаж`,
    en: `floor`,
    cn: `楼层`
  }
};

//TODO: use modal-floors module instead of this one
class ModalFlatsPlans extends Modal {
  constructor() {
    super();
    this.footer = this.page.querySelector(`.page-footer`);
    this.toggles = [...this.page.querySelectorAll(`.js-gallery-plans`)];
    this.plans = [];
    this.wrap = null;
    this.slider = null;
    this.options = null;
    this.activeFloor = 0;
  };

  init(locale) {
    this.locale = locale;
    super.createModal();
  };

  createContent({floors} = {}) {
    this.plans = this.sortFloors(floors);
    this.createWrap();
    this.toggleModal(true);
    this.bindHandlers();
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
    this.footer.classList.add(classNames.footer.static);
  };

  onClose = () => {
    this.footer.classList.remove(classNames.footer.static);
  };

  createWrap() {
    super.addLayout(getLayout(`flat-floors`));
    this.createFloorsItems();
  };

  createFloorsItems() {
    const wrap = this.page.querySelector(`#floors-modal`);
    const list = document.createElement(`ul`);
    const items = this.renderFloorsLayout(this.plans);
    let options;

    wrap.innerHTML = ``;
    list.className = `modal-floors__slider modal-slider`;
    list.innerHTML = items;
    wrap.appendChild(list);

    if (this.plans.length > 1) {
      options = this.renderListOptions(this.plans);
      wrap.appendChild(options);

      this.options = [...this.page.querySelectorAll(`.modal-floors__option`)];
      this.slider = list;
      this.initSlider();
    }

    this.wrap = wrap;
  };

  renderFloorsLayout = (plans) => {
    const renderPlan = (plan) => {

      let flatPlanLocale = plan[`flat_plan_${this.locale}`];

      if (!flatPlanLocale) {
        flatPlanLocale = plan[`flat_plan_ru`];
      };

      return flatPlanLocale ? `<div class="modal-floors__floor">
                <img src="${flatPlanLocale}" alt="Планировка этажа">
              </div>` : ``;
    };

    return plans.map(renderPlan).join(``);
  };

  initSlider = () => {
    $(this.slider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true
    });

    this.options[0].classList.add(classNames.options.optionActive);

    $(this.slider).on('afterChange', (event, slick, currentSlide) => {
      this.toggleOptionsState(this.options[currentSlide]);
    });
  };

  toggleOptionsState = (option) => {
    const siblings = getSiblings(option);

    option.classList.add(classNames.options.optionActive);
    siblings.forEach(sibling => sibling.classList.remove(classNames.options.optionActive));
  };

  renderListOptions(plans) {
    const wrap = document.createElement(`div`);
    const renderOption = (plan) => {
      return `<div class="modal-floors__option">${plan[`floor_number`]} ${texts[`floor`][this.locale]}</div>`
    };
    const options = plans.map(renderOption).join(``);

    wrap.className = `modal-floors__options`;
    wrap.innerHTML = options;

    return wrap;
  };

  sortFloors(floors) {
    return floors.sort((a, b) => {
      return a[`floor_number`] < b[`floor_number`] ? -1 : 1;
    });
  };

  optionsHandler() {
    this.options.forEach((option, index) => {
      option.addEventListener(`click`, () => {
        $(this.slider).slick('slickGoTo', index);
      })
    })
  };

  bindHandlers() {
    if (this.plans.length > 1) {
      this.optionsHandler();
    }
  }
}


const modalFlatsPlans = new ModalFlatsPlans();

export default modalFlatsPlans;
